<div class="content-wrapper" [ngClass]="{'disable': step.status===StepStaus.DISABLE}">
    <lib-stepper-icon [stepStaus]="step.status" [title]="step.title"></lib-stepper-icon>
    <div class="main-content" [ngClass]="{'step-dash-border': step.style===StepStyle.DASHED, 'step-dash-border-disable': step.style===StepStyle.DASHED && step.status === StepStaus.DISABLE}">
        <ng-content></ng-content>
    </div>

</div>
